/*
 * @Autor: suhang
 * @Date: 2022-05-18 08:19:22
 * @LastEditors: suhang
 * @LastEditTime: 2022-05-18 08:42:09
 * @Description: 404路由
 */

import { RouteRecordRaw } from "vue-router";

export const notFoundRoutes: Array<RouteRecordRaw> = [
    {
        path: "/privacy",
        name: "privacy",
        component: () =>
            import(
                /* webpackChunkName: "404" */ "@/views/privacy/privacy.vue"
                ),
    },
    {
        path: "/404",
        name: "404",
        component: () =>
            import(
                /* webpackChunkName: "404" */ "@/views/404"
            ),
    },
    {
        path: "/:pathMatch(.*)*",
        redirect: "/404"
    }
]